import { render } from "./PrecisionPicksPage.vue?vue&type=template&id=274ee0bf&ts=true"
import script from "./PrecisionPicksPage.vue?vue&type=script&lang=ts"
export * from "./PrecisionPicksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__